// filter
const pagination = () => ({
    limit: 10,
    offset: 0,
    length: 0,
    pageNumber: 0,
});

const state = {
    isSearch: false,
    jenis: 0,
    listSnapConsole: [],

    pagination: pagination(),
}

export {
    state as default,
    pagination,
}